/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getReceipt} from '../api'

 export const useQueryGetReceipt = createReactQueryHook('getReceipt', getReceipt)
